
export default {
    namespaced: true,
    state: {
        currentPage:1,
        tatolPage:1,
        pageSize:10,
        districtName:{
            cityAreaDynamic:"县区动态",
            cityRecruitStudents:"招生政策",
            cityWarningInfo:"招生预警信息",
            distDegree:"学位占用查询",
            distGuide:"办事指南",
            distRecruitStudents:"招生政策",
            distSchDistrict:"学区查询",
            distTransfer:"转学申请",
            distWarningInfo:"招生预警信息"

        }
        
    },

    actions: {
        setCurrentPage({ commit }, payload){
            commit('setCurrentPage', payload);
        },
        setTotalPage({ commit }, payload){
            commit('setTotalPage', payload);
        },


    },

    mutations: {
        setCurrentPage(state,payload){
            if(payload=="pre"){
                state.currentPage=state.currentPage-1
            }else if(payload=="next"){
                state.currentPage=state.currentPage+1
            }else if(payload=="first"){
                state.currentPage=1
            }else{
                state.currentPage=state.tatolPage
            }

        },

        setTotalPage(state,payload){
            state.tatolPage=payload

        }





    }









}